import { useState } from 'react';
import { MapPin } from 'lucide-react';

interface ProjectLocationProps {
  city: string;
  subCity?: string | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

const poiCategories = ['All', 'Schools', 'Restaurants', 'Hospitals', 'Parks'];

export function ProjectLocation({ city, subCity, address, latitude, longitude }: ProjectLocationProps) {
  const [activePoi, setActivePoi] = useState('All');
  const hasCoords = latitude && longitude;

  return (
    <section className="max-w-full overflow-hidden">
      <h2 className="font-display text-lg md:text-xl font-bold mb-3 md:mb-4">Location</h2>
      <div className="space-y-3">
        {/* POI filter tabs */}
        {hasCoords && (
          <div className="flex gap-2 flex-wrap">
            {poiCategories.map(cat => (
              <button
                key={cat}
                onClick={() => setActivePoi(cat)}
                className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all ${
                  activePoi === cat
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        )}

        {/* Map */}
        {hasCoords ? (
          <div className="aspect-[16/9] w-full max-w-full rounded-xl overflow-hidden border">
            <iframe
              title="Project Location"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              src={`https://www.openstreetmap.org/export/embed.html?bbox=${longitude! - 0.01},${latitude! - 0.01},${longitude! + 0.01},${latitude! + 0.01}&layer=mapnik&marker=${latitude},${longitude}`}
            />
          </div>
        ) : (
          <div className="border rounded-xl p-4 md:p-6">
            <div className="flex items-start gap-3">
              <MapPin className="h-5 w-5 text-primary mt-0.5 shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-sm break-words">{city}{subCity ? `, ${subCity}` : ''}</div>
                {address && <div className="text-sm text-muted-foreground break-words">{address}</div>}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
